import { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import BotManager from './BotManagerMain';
import RpabotManager from './RpabotManager';
import BotAssistant from './BotAssistantMain';
import RpaBotAssistant from './RPABotAssistant';

const BotManagerPage = () => {
  const location = useLocation();
  const [focusTaskId, setFocusTaskId] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<'tasks' | 'rpa' | 'assistant' | 'rpa-assistant'>(() => {
    const saved = localStorage.getItem('bot_manager_active_tab');
    if (saved === 'tasks' || saved === 'rpa' || saved === 'assistant' || saved === 'rpa-assistant') {
      return saved as 'tasks' | 'rpa' | 'assistant' | 'rpa-assistant';
    }
    return 'tasks';
  });

  useEffect(() => {
    const loc = location as any;
    if (loc.state && typeof loc.state.activeTab === 'string') {
      setActiveTab(loc.state.activeTab as 'tasks' | 'rpa' | 'assistant' | 'rpa-assistant');
      if (loc.state.focusTaskId) {
        setFocusTaskId(loc.state.focusTaskId);
      }
      try {
        window.history.replaceState(null, '');
      } catch (e) {
        console.error('Failed to clear history state:', e);
      }
    }
  }, [location]);

  useEffect(() => {
    localStorage.setItem('bot_manager_active_tab', activeTab);
  }, [activeTab]);

  const userId = localStorage.getItem('id') || '';
  const username = localStorage.getItem('UserName') || '';
  const userType = localStorage.getItem('UserType') || '';

  return (
    <Fragment>
      <Breadcrumbs mainTitle='Bot Manager' title='Bot Manager' />
      <Card>
        <CardBody>
          <div className='my-nav'>
            <Nav tabs className='nav-fill'>
              <NavItem className='tabcont'>
                <NavLink
                  className={classnames('nav-link', { active: activeTab === 'tasks' })}
                  onClick={() => { setActiveTab('tasks'); setFocusTaskId(null); }}
                >
                  IPA Bot Management
                </NavLink>
              </NavItem>
              <NavItem className='tabcont'>
                <NavLink
                  className={classnames('nav-link', { active: activeTab === 'assistant' })}
                  onClick={() => { setActiveTab('assistant'); setFocusTaskId(null); }}
                >
                  IPA Bot Log
                </NavLink>
              </NavItem>
              <NavItem className='tabcont'>
                <NavLink
                  className={classnames('nav-link', { active: activeTab === 'rpa' })}
                  onClick={() => { setActiveTab('rpa'); setFocusTaskId(null); }}
                >
                  RPA Bot Management
                </NavLink>
              </NavItem>
              <NavItem className='tabcont'>
                <NavLink
                  className={classnames('nav-link', { active: activeTab === 'rpa-assistant' })}
                  onClick={() => { setActiveTab('rpa-assistant'); setFocusTaskId(null); }}
                >
                  RPA Bot Log
                </NavLink>
              </NavItem>
            </Nav>
          </div>

          <CardBody>
            <TabContent activeTab={activeTab}>
              <TabPane tabId='tasks'>
                <BotManager isActive={activeTab === 'tasks'} setActiveTab={setActiveTab} />
              </TabPane>
              
              <TabPane tabId='assistant'>
                <BotAssistant focusTaskId={focusTaskId} isActive={activeTab === 'assistant'} />
              </TabPane>

              <TabPane tabId='rpa'>
                <RpabotManager isActive={activeTab === 'rpa'} setActiveTab={setActiveTab} />
              </TabPane>

              <TabPane tabId='rpa-assistant'>
                <RpaBotAssistant focusTaskId={focusTaskId} isActive={activeTab === 'rpa-assistant'} />
              </TabPane>
            </TabContent>
          </CardBody>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default BotManagerPage;
